import React from "react"
import { Container } from "reactstrap"
import { useAuth0 } from "@auth0/auth0-react"

const LoginPage = () => {
  const { loginWithRedirect } = useAuth0()
  return (
    <div>
      <Container fluid className="login-body-padding home-button">
        <button
          type="button"
          className="btn btn-primary btn-lg"
          onClick={() => loginWithRedirect()}
        >
          <div>Get Started</div>
        </button>
      </Container>
    </div>
  )
}

export default LoginPage
